import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  root: { left: 405 },
  alert: {
    backgroundColor: theme.palette.brand.white,
    color: theme.palette.brand.greenDark,
    boxShadow: theme.boxShadow.main,
    zIndex: 10000,
  },
}));

export default function CustomAlert({
  open,
  children,
}: {
  open: boolean;
  children: React.ReactNode;
}) {
  const classes = useStyles();
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      className={classes.root}
    >
      <SnackbarContent
        className={classes.alert}
        message={<div>{children}</div>}
      />
    </Snackbar>
  );
}
